<template>
  <settings-modal class="profile-fee-enable-modal">
    <template slot="heading">Remove “{{ disabledFeeName }}” from disabled list?</template>

    <error-alert :error="error" />

    <template slot="actions">
      <v-btn
        id="t-confirm-remove"
        color="primary"
        medium
        flat
        :disabled="loading"
        @click="onConfirmButtonClick"
      >confirm</v-btn>

      <v-btn
        class="t-close-modal"
        color="primary"
        medium
        flat
        @click="onCloseButtonClick"
      >close</v-btn>
    </template>
  </settings-modal>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex'

  // Events
  import { EVENT_FEE_DISABLE } from '@/events/fees'

  // Services
  import ApiRequest from '@/services/ApiRequests/ApiRequest'
  import ProfileApi from '@/services/Api/ProfileApi'

  // Components
  import SettingsModal from '@/components/modals/SettingsModal'
  import ErrorAlert from '@/components/ui/ErrorAlert'

  export default {
    name: 'ProfileFeeEnableModal',
    components: {
      SettingsModal,
      ErrorAlert
    },
    data () {
      return {
        profileFeeEnableApiRequest: new ApiRequest(ProfileApi.enableFee)
      }
    },
    computed: {
      ...mapGetters('modal', ['modal']),
      disabledFeeName () {
        return this.modal.data.disabledFeeName
      },
      disabledFee () {
        return this.modal.data.disabledFee
      },
      loading () {
        return this.profileFeeEnableApiRequest.loading
      },
      error () {
        return this.profileFeeEnableApiRequest.error
      }
    },
    methods: {
      ...mapActions('modal', ['showModal', 'closeModal']),
      onConfirmButtonClick () {
        this.profileFeeEnableApiRequest
          .execute(this.disabledFee.profileId, this.disabledFee.feeType)
          .then(this.profileFeeEnableSuccessHandler)
          .catch(() => {})
      },
      onCloseButtonClick () {
        this.closeModal()
      },
      profileFeeEnableSuccessHandler () {
        this.$eventHub.$emit(EVENT_FEE_DISABLE)
        this.closeModal()

        setTimeout(() => {
          this.showModal({
            name: 'SuccessFlashModal',
            data: { message: 'Fee has been successfully removed from disabled list.' }
          })
        }, 100)
      }
    }
  }
</script>
